export const PwaHelperMixin = {
  computed: {
    isPwa() {
      return window.matchMedia("(display-mode: standalone)").matches;
    },
  },
};
